import React from 'react';
import adjustifyLogo from '../images/companies/adjustify.svg';

// Shared SVG assets for Companies and Claim Status.
// Uploaded company logos take precedence over bundled assets.
export const COMPANY_LOGOS = {
  'adjustify claims': adjustifyLogo,
};

export function getCompanyLogo(company, uploadedLogo) {
  return uploadedLogo || COMPANY_LOGOS[(company || '').trim().toLowerCase()] || null;
}

export default function CompanyLogos({ company, src, className = '' }) {
  const logo = getCompanyLogo(company, src);
  return logo
    ? <img src={logo} alt={company || ''} className={className} />
    : <i className="fa-solid fa-building" aria-hidden="true" />;
}
